import { type ReactNode, useEffect, useId, useRef } from 'react';

export default function ModerationDialog({
  title,
  children,
  comparison = false,
  onClose,
}: {
  title: string;
  children: ReactNode;
  comparison?: boolean;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const dialog = ref.current;
    const trigger = document.activeElement;
    dialog?.showModal();
    return () => {
      dialog?.close();
      requestAnimationFrame(() => {
        if (!dialog?.open && trigger instanceof HTMLElement && trigger.isConnected) trigger.focus();
      });
    };
  }, []);
  return (
    <dialog
      ref={ref}
      className={`scs-moderation-dialog${comparison ? ' scs-moderation-dialog--comparison' : ''}`}
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
    >
      <div className="scs-moderation-dialog__header">
        <h2 id={titleId} className="govuk-heading-m govuk-!-margin-bottom-0">
          {title}
        </h2>
        <button
          type="button"
          className="scs-moderation-dialog__close"
          aria-label="Close popup"
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {children}
    </dialog>
  );
}
